<g id="daymarker-{{id}}"
    class="day-marker"
    transform="translate(0,{{position}})"
    stroke="{{color}}"
    stroke-linecap="round" stroke-width=".6"
    >
    <rect x="-72" y="8" width="15" height="10" stroke="none" fill="#fff"/>
    <circle cx="-89.51" cy="15.12" r="4" fill="none" stroke-linejoin="round" style="paint-order:markers fill stroke"/>
    <path d="m-89.51 7.191v2.782" fill="none"/>
    <path d="m-85.14 8.244c-1.568 2.469-1.529 2.41-1.529 2.41"/>
    <path d="m-81.95 11.137c-2.715 1.426-2.65 1.391-2.65 1.391"/>
    <path d="m-80.77 15.1c-3.136-2e-6 -3.06-1e-6 -3.06-1e-6"/>
    <path d="m-81.93 19.06c-2.715-1.426-2.65-1.391-2.65-1.391"/>
    <path d="m-85.12 21.97c-1.568-2.469-1.529-2.41-1.529-2.41"/>
    <path d="m-89.47 23.04v-2.782"/>
    <path d="m-93.83 21.99c1.568-2.47 1.529-2.41 1.529-2.41"/>
    <path d="m-97.03 19.09c2.715-1.426 2.65-1.391 2.65-1.391"/>
    <path d="m-98.2 15.13c3.136 1e-6 3.06 1e-6 3.06 1e-6"/>
    <path d="m-97.05 11.166c2.715 1.426 2.65 1.391 2.65 1.391"/>
    <path d="m-93.86 8.256c1.568 2.47 1.529 2.41 1.529 2.41"/>
    <text id="daymarker-{{id}}-text" x="-57" y="17.1" text-anchor="end"fill="{{color}}" font-size="8px" stroke-width=".2646">
        {{value}}°C
    </text>
</g>
